import React, { useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobileNumber: "",
    gmail: "",
    course: "",
    year: "",
  });
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("Submitting...");

    try {
      const response = await axios.post(
        "https://script.google.com/macros/s/AKfycbwyDvbiBoeB1kT-HcSlvwEYTNwiJcILZSTcGZkLmzdH4EgQUeU6x3y3fZnK22fJN-hlsw/exec",
        formData
      );

      if (response.data.status === "success") {
        setMessage("✅ Thank you! Your details have been submitted successfully.");
        setFormData({ name: "", mobileNumber: "", gmail: "", course: "", year: "" });
      } else {
        setMessage(`❌ Error: ${response.data.message}`);
      }
    } catch (error) {
      setMessage("⚠️ Submission failed. Please try again later.");
    }
  };

  return (
    <div className="contact-page" style={{ backgroundColor: "#f5f7fa" }}>
      {/* Padding added to prevent overlap with Navbar */}
      <div style={{ paddingTop: "90px" }}>
        {/* Header Section */}
          <section
        className="text-center text-white py-5"
        style={{
          background: "linear-gradient(120deg, #001f3f, #0056b3)",
        }}
      >
        <div className="container">
          <h1 className="fw-bold display-5 mb-3">Contact Olewin Academy</h1>
          <p className="lead mb-0">
            India’s 1st Research & Training Academy offering <strong>Live Classes</strong> & <strong>Paid Internships</strong>.
          </p>
            <p className="lead">
              India’s 1st Research & Training Academy offering <b>Live Classes</b>, <b>Hybrid Learning</b>,
              and <b>Paid Internships</b> across multiple programs.
            </p>
        </div>
      </section>

      

        {/* Main Content Section */}
        <section className="py-5">
          <div className="container">
            <div className="row g-5">
              {/* Left Info Section */}
              <div className="col-lg-6 d-flex align-items-center">
                <div>
                  <h3 className="fw-bold mb-3 text-primary">Why Choose Olewin Academy?</h3>
                  <p className="text-muted">
                    Our online training combines <b>2 hours of daily live interactive sessions</b> with
                    real-world project experience. We prepare students, professionals, and institutions for
                    tomorrow’s challenges with India’s only <b>Research-Integrated Paid Internship Model</b>.
                  </p>

                  <ul className="list-group list-group-flush mb-3">
                    <li className="list-group-item">✅ Live 2-hour online classes every day</li>
                    <li className="list-group-item">✅ Real-time project-based hybrid learning</li>
                    <li className="list-group-item">✅ Paid internship after training completion</li>
                    <li className="list-group-item">✅ Certification & Letter of Recommendation</li>
                    <li className="list-group-item">✅ Placement guidance for all trainees</li>
                  </ul>

                  <h5 className="fw-bold mt-4">📞 Contact Us</h5>
                  <p className="mb-1">📱 +91 8639449423</p>
                  <p className="mb-1">✉️ info@olewinacademy.com</p>
                  <p>🌐 www.olewinacademy.com</p>
                </div>
              </div>

              {/* Right Form Section */}
              <div className="col-lg-6">
                <div className="card border-0 shadow-lg rounded-4">
                  <div className="card-body p-4">
                    <h4 className="fw-bold text-center mb-4 text-primary">
                      Contact / Request Information
                    </h4>
                    <form onSubmit={handleSubmit}>
                      <div className="mb-3">
                        <label className="form-label">Full Name</label>
                        <input
                          type="text"
                          name="name"
                          className="form-control"
                          placeholder="Enter your full name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Mobile Number</label>
                        <input
                          type="tel"
                          name="mobileNumber"
                          className="form-control"
                          placeholder="Enter your mobile number"
                          pattern="[0-9]{10}"
                          value={formData.mobileNumber}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Email (Gmail)</label>
                        <input
                          type="email"
                          name="gmail"
                          className="form-control"
                          placeholder="Enter your email address"
                          value={formData.gmail}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Select Program / Course</label>
                        <select
                          name="course"
                          className="form-select"
                          value={formData.course}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select a course</option>
                          <option value="IIT-JEE">IIT-JEE (Engineering Entrance)</option>
                          <option value="NEET">NEET (Medical Entrance)</option>
                          <option value="GATE">GATE / IIT-JAM</option>
                          <option value="CA-CPT">CA / CPT / CS Foundation</option>
                          <option value="LAW">LAW (CLAT / AILET)</option>
                          <option value="Abroad">Abroad (IELTS / GRE / TOEFL)</option>
                          <option value="AI-ML">AI, ML & Data Science</option>
                          <option value="Quantum">Quantum & Space Technology</option>
                          <option value="Energy">Energy, GeoScience & Renewables</option>
                          <option value="FullStack">Full Stack Web / App Development</option>
                        </select>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Academic Year</label>
                        <input
                          type="number"
                          name="year"
                          className="form-control"
                          placeholder="Enter your year (e.g., 2025)"
                          value={formData.year}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <button type="submit" className="btn btn-primary w-100 fw-bold">
                        Submit Details
                      </button>
                    </form>

                    {message && (
                      <div className="alert alert-info mt-3 text-center fw-semibold">
                        {message}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

    
      </div>
    </div>
  );
};

export default ContactPage;
